<template>
		<v-container>
			<div class="base-page">
				<logo-with-title :title="$t('payment.thankYouPage.title')" />

			<v-row align="start" justify="center">
				<v-col>
					<h2 class="primary--text">{{ $t('payment.thankYouPage.paymentSuccess') }}</h2>
					<h3 class="text-center mt-5">
						{{ $t('payment.thankYouPage.emailConfirmation') }}
					</h3>
				</v-col>
			</v-row>
			<v-row v-if="loading" align="center" justify="center">
					<v-progress-circular
						:size="100"
						:width="10"
						color="primary"
						class="mt-3"
						indeterminate
					/>
			</v-row>
			<v-row v-if="!autoRedirect">
				<v-col
					class="d-flex justify-center"
				>
				<v-btn :href="redirectLink" text color="btnColor">
					<span class="font-weight-bold text-h3">
						{{ $t('payment.thankYouPage.goToProject') }}
					</span>
				</v-btn>

					<v-btn
					text 
						color="primary"
						:to="{name:'purchase-history'}"
					>					<span class="font-weight-bold text-h3">

						{{ $t('payment.thankYouPage.paymentHistory') }}
					</span>
					</v-btn>
				</v-col>
			</v-row>
		
			<div v-else>
				<v-row align="center" justify="center" class="mt-8">

						<div class="text-center textColor--text font-weight-medium text-h2	">
							{{ $t('payment.thankYouPage.redirectingMessage') }}
						</div>
				</v-row>
				<v-row>
					<v-col>
						<v-progress-linear
							v-model="progressVal"
							height="10"
							color="white"
						/>
					</v-col>
				</v-row>
			</div>
			<v-row>
				<lang-select/>
			</v-row>
		</div>
	</v-container>

</template>

<script>
import { types } from "@/store/modules/Project.module";
import LogoWithTitle from "@/components/LogoWithTitle";
import LangSelect from "@/components/LangSelect";
export default {
	name: "ThankYouPage",
	components: { LogoWithTitle, LangSelect },
	data () {
		return {
			autoRedirect: false,
			progressVal: 0,
			loading: true
		};
	},
	computed: {
		redirectLink () {
			const token = this.$route.query.token;
			const params = JSON.parse(window.localStorage.getItem("queryString"));
			let queryString = "";
			Object.entries(params).forEach(([key, value]) => {
				queryString += "&" + key + "=" + value;
			});
			return "/api/redirectToProject?token=" + token + queryString;
		},
	},
	watch: {
		value () {
			return 10;
		},
	},
	async created () {
		this.runFacebookPixel();
		const project = sessionStorage.getItem("activeProject");
		await this.$store.dispatch(types.GET, project).then((response) => {
			if (response.show_redirect) {
				this.autoRedirect = false;
				this.loading = false;

			} else {
				this.autoRedirect = true;
				this.startRedirect();
			}
		});
	},
	methods: {
		startBuffer () {
			setInterval(() => {
				this.progressVal += 1;
			}, 1);
		},
		startRedirect () {
			const TIME_OUT = 2000;
			this.startBuffer();
			setTimeout(() => {
				window.location = this.redirectLink;
			}, TIME_OUT);
		},
		runFacebookPixel () {
			fbq('init', '671705102368420');
			fbq('track', 'PageView');
		}
	},
};
</script>

<style lang="scss" scoped>

</style>
